// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SRqu","colMin":"styles_colMin__2hVzx"};